// TimeList Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget as dropTarget } from 'react-dnd'

import TimeItem from '../../time/time_item/time_item.jsx'
import TimeMessage from '../../time/time_message/time_message.jsx'
import Acl from '../../../lib/acl.jsx'

const timeTarget = {
  canDrop (props) {
    return props.canDrop
  },
  drop (props, monitor) {
    props.onDrop(monitor.getItem())
  }
}

@dropTarget(
  _props => 'all',
  timeTarget,
  (connect, _monitor) => ({
    connectDropTarget: connect.dropTarget()
  })
)
class TimeList extends Component {
  static get propTypes () {
    return {
      timeCards: PropTypes.array,
      editTimeCardId: PropTypes.string,
      loggedInId: PropTypes.string,
      bMessageIgnoreTimer: PropTypes.bool,
      canDrop: PropTypes.bool,
      timer: PropTypes.object.isRequired,
      onSave: PropTypes.func,
      onUpdateFavorite: PropTypes.func,
      onOpenForm: PropTypes.func,
      onCloseForm: PropTypes.func,
      onDelete: PropTypes.func,
      onTimerStart: PropTypes.func,
      onTimerPause: PropTypes.func,
      onTimerFinalize: PropTypes.func,
      onShowDetailForm: PropTypes.func,
      onDrop: PropTypes.func,
      connectDropTarget: PropTypes.func,
      onMessageAdd: PropTypes.func,
      onMessageStart: PropTypes.func,
      onTimerStop: PropTypes.func,
      stopAndCreateNewTimeCard: PropTypes.func,
      onShowError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      timeCards: [],
      editTimeCardId: null,
      loggedInId: null,
      canDrop: false,
      bMessageIgnoreTimer: false,
      onSave: null,
      onUpdateFavorite: null,
      onOpenForm: null,
      onCloseForm: null,
      onDelete: null,
      onTimerStart: null,
      onTimerPause: null,
      onTimerFinalize: null,
      onShowDetailForm: null,
      onDrop: null,
      connectDropTarget: null,
      onMessageAdd: PropTypes.func,
      onMessageStart: PropTypes.func,
      onTimerStop: null,
      stopAndCreateNewTimeCard: null,
      onShowError: null
    }
  }

  render () {
    const {
      timeCards,
      editTimeCardId,
      loggedInId,
      timer,
      onSave,
      onUpdateFavorite,
      onOpenForm,
      onCloseForm,
      onDelete,
      onTimerStart,
      onTimerPause,
      onTimerFinalize,
      onShowDetailForm,
      connectDropTarget,
      onTimerStop,
      stopAndCreateNewTimeCard,
      onShowError
    } = this.props

    let totalTimeTaken = 0
    timeCards.forEach(time => {
      totalTimeTaken += time.timeTaken
    })

    // For 3 Timescards: A=5, B=12, C=6
    // Total time = 23, Remaining Hours = 1 (24 - 23)
    // For A Max time allowed = 6
    // For B Max time allowed = 13
    // For C Max time allowed = 7
    const totalRemainingMins = 24 * 60 - totalTimeTaken

    return connectDropTarget(
      <div className='timeitems'>
        {this._renderMessage()}
        {timeCards.map((time, _idx) => (
          <TimeItem
            time={time}
            key={time.id}
            active={editTimeCardId === time.id}
            inActive={editTimeCardId && editTimeCardId !== time.id}
            canEdit={time.userId === loggedInId || Acl.isRoleProjectManager()}
            canStartTimer={time.userId === loggedInId}
            timer={timer}
            onSave={onSave}
            onUpdateFavorite={onUpdateFavorite}
            onOpenForm={onOpenForm}
            onCloseForm={onCloseForm}
            onDelete={onDelete}
            onTimerStart={onTimerStart}
            onTimerPause={onTimerPause}
            onTimerFinalize={onTimerFinalize}
            onShowDetailForm={onShowDetailForm}
            remainingMins={totalRemainingMins + time.timeTaken}
            onShowError={onShowError}
            onTimerStop={onTimerStop}
            stopAndCreateNewTimeCard={stopAndCreateNewTimeCard}
          />
        ))}
      </div>
    )
  }

  /* Private functions */
  _renderMessage () {
    const {
      bMessageIgnoreTimer,
      timeCards,
      onMessageAdd,
      onMessageStart
    } = this.props

    if (timeCards.length > 0) {
      return null
    }

    return (
      <TimeMessage
        message='task.form.noTaskTitle'
        ignoreTimer={bMessageIgnoreTimer}
        onAdd={onMessageAdd}
        onStart={onMessageStart}
      />
    )
  }
}

export default TimeList
